import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <section className="mx-auto flex max-w-content flex-col items-start px-6 py-32" data-id="element-214" data-mp="w3ztfmzgnvxh">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-indigo" data-id="element-215" data-mp="w643ynrv7t6q">
        404
      </p>
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-navy-800" data-id="element-216" data-mp="154plqgpij46g">
        Page not found
      </h1>
      <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-217" data-mp="1a4kd0ld79vs1" />
      <p className="mt-6 max-w-md text-base leading-relaxed text-navy-500" data-id="element-218" data-mp="1f1arx5d9qlbv">
        The page you requested does not exist or has been moved.
      </p>
      <Link to="/" className="mt-8 inline-flex items-center justify-center rounded-lg border border-brand-indigo/30 bg-white px-6 py-3.5 text-sm font-semibold text-brand-indigo transition-colors hover:border-brand-indigo hover:bg-brand-indigo/5" data-id="element-219" data-mp="1nvywetb0ryzm">
        Return home
      </Link>
    </section>;
}